const virtualMarketIds = [
  `fm`, // reference content
  `sb`, // playground
];

/**
 * @returns ISO 3166-1 alpha-2 country code (e.g `'DE'`)
 */
export function getCountryCode(marketId: string): string {
  return virtualMarketIds.includes(marketId) ? `DE` : marketId.toUpperCase();
}
